import React, { lazy, Suspense } from 'react';

const LazyUnderMaintenance = lazy(() => import('./UnderMaintenance'));

const UnderMaintenance = props => (
  <Suspense fallback={null}>
    <LazyUnderMaintenance {...props} />
  </Suspense>
);

export default UnderMaintenance;
